import { useState, useEffect } from 'preact/hooks';

interface IColumnVisibilityModalProps {
    isOpen: boolean;
    onClose: () => void;
    columns: string[];
    columnLabels: Record<string, string>;
    visibleColumns: string[];
    onToggleColumn: (newVisibleColumns: Set<string>) => void;
}

export default function ColumnVisibilityModal({
    isOpen,
    onClose,
    columns,
    columnLabels,
    visibleColumns,
    onToggleColumn,
}: IColumnVisibilityModalProps) {
    const [localVisibleColumns, setLocalVisibleColumns] = useState<Set<string>>(new Set(visibleColumns));

    useEffect(() => {
        if (isOpen) {
            setLocalVisibleColumns(new Set(visibleColumns));
        }
    }, [isOpen, visibleColumns]);

    const handleToggle = (column: string) => {
        const newSet = new Set(localVisibleColumns);
        if (newSet.has(column)) { newSet.delete(column); } else { newSet.add(column); }
        setLocalVisibleColumns(newSet);
    };

    const handleApply = () => {
        onToggleColumn(localVisibleColumns);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col">
                <div className="p-6 border-b border-base-300">
                    <h2 className="text-xl font-bold">Выбор колонок для отображения</h2>
                </div>

                <div className="flex-1 overflow-y-auto p-6">
                    <div className="flex justify-end gap-2 mb-4">
                        <button type="button" className="btn btn-sm btn-ghost" onClick={() => setLocalVisibleColumns(new Set(columns))}>
                            Выбрать все
                        </button>
                        <button type="button" className="btn btn-sm btn-ghost" onClick={() => setLocalVisibleColumns(new Set())}>
                            Снять все
                        </button>
                    </div>

                    <div className="space-y-2">
                        {columns.map((column) => {
                            const label = columnLabels[column] || column;
                            const textLabel = label.replace(/<[^>]*>/g, '');
                            return (
                                <label key={column} className="flex items-center gap-3 p-3 hover:bg-base-200 rounded-md cursor-pointer transition-colors">
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                                        checked={localVisibleColumns.has(column)}
                                        onChange={() => handleToggle(column)}
                                    />
                                    <span className="flex-1 text-sm">{textLabel}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                <div className="p-6 border-t border-base-300 flex justify-end gap-2">
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-accent" onClick={handleApply}>Применить</button>
                </div>
            </div>
        </div>
    );
}
